import { RouteObject } from 'react-router-dom';
import UrunDetayPage from '@/pages/urun/page';
import HomePage from '@/pages/home/page';
import IkinciElPage from '@/pages/ikinci-el/page';
import YazilimPage from '@/pages/yazilim/page';
import IletisimPage from '@/pages/iletisim/page';
import PanelPage from '@/pages/panel/page';
import GizlilikPage from '@/pages/gizlilik/page';
import KullanimSartlariPage from '@/pages/kullanim-sartlari/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/ikinci-el', element: <IkinciElPage /> },
  { path: '/yazilim', element: <YazilimPage /> },
  { path: '/iletisim', element: <IletisimPage /> },
  { path: '/panel', element: <PanelPage /> },
  { path: '/urun/:id', element: <UrunDetayPage /> },
  { path: '/gizlilik', element: <GizlilikPage /> },
  { path: '/kullanim-sartlari', element: <KullanimSartlariPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
